import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class DeclarationMaintenanceService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/declaration-maintenance/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/declaration-maintenance/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/declaration-maintenance/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/declaration-maintenance/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/declaration-maintenance/delete/${id}`), callback);

}